import garden from './assets/garden-preview.jpg';
import pink from './assets/pink-preview.jpg';
import peonies from './assets/peonies-preview.jpg';

// Published business details; owner confirmation is required before launch.
export const business = {
  name: 'Boho Florals',
  owner: 'Kaylin Hamilton',
  location: 'Camden, Tennessee',
  address: '99 E. Lake St, Camden, TN 38320',
  phone: '731-220-5188',
  phoneHref: 'tel:+17312205188',
  canonicalUrl: 'https://joegalaxy.net/BohoFlorals',
  inquiryDestination: null,
};

export const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(business.address)}`;
export const heroImage = garden;
export const services = [
  { id: 'everyday', title: 'Everyday flowers', occasion: 'Gifts & everyday flowers', description: 'A birthday, a thank-you, a just-because. Flowers for the little things that mean a lot.', action: 'Request an arrangement' },
  { id: 'weddings', title: 'Weddings & events', occasion: 'Weddings & events', description: 'From the bouquet you hold to the tables you gather around. Tell us about your day.', action: 'Share your plans' },
  { id: 'sympathy', title: 'Sympathy & remembrance', occasion: 'Sympathy & remembrance', description: 'A thoughtful way to express love, offer comfort and remember someone special.', action: 'Inquire about flowers' },
];
export const occasions = [...services.map(service => service.occasion), 'Floral subscriptions', 'Something else'];
export const gallery = [
  { id: 'garden-romance', src: garden, title: 'Garden romance', alt: 'Illustrative garden roses, cosmos and yellow ranunculus in a white vase', credit: 'AI-generated preview image', width: 1536, height: 1024 },
  { id: 'a-little-pink', src: pink, title: 'A little pink', alt: 'Sample close-up photograph of pink daisies', credit: 'Arthur Avakov / Unsplash', creditUrl: 'https://unsplash.com/photos/a-bunch-of-pink-flowers-in-a-vase-Lhkf9sQYiaU', width: 900, height: 600 },
  { id: 'soft-seasonal', src: peonies, title: 'Soft & seasonal', alt: 'Sample photograph of a pink peony bouquet in a glass vase', credit: 'Evie Fjord / Unsplash', creditUrl: 'https://unsplash.com/photos/pink-roses-in-clear-glass-vase-nR3heTF3O1U', width: 900, height: 1350 },
];
